import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { currentUserLogout } from '../../redux/actions/currentUserActions';
import LoadingSpinner from './LoadingSpinner';
import { FormattedMessage } from 'react-intl';
import { persistor } from '../../store';
import { controller } from '../../redux/middleware/apiMiddleware';
import { isDev } from '../../utilities/general';
/**
 * Function to redirect to login. This is for the logout process so that when the redux store is wiped, the user is then redirected to the login page the same way they would be via php
 */

function RedirectToLogin(props) {
  const location = useLocation();
  const { state } = location;
  const status = state?.status;
  const linkRef = useRef();

  let addr =  isDev() ? '/' : '/index.php?mode=logout';

  switch (status) {
    case 'invalidToken':
      addr =  isDev() ? '/' : '/index.php?mode=logout&status=6';
      break;

    default:
      break;
  }

  useEffect(() => {
    // stop all active api fetch calls
    controller.abort();
    // pause any data going to the local storage persist store
    persistor.pause();
    // dispatch the action to clear the redux store
    props.dispatch(currentUserLogout());
    // flush any data that's being written to the local persist storage
    persistor.flush().then(() => {
      // when the flush is done purge the local store
      return persistor.purge();
    });
    // give everything 1.5 sec to happen then click the link to redirect the browser to the login screen
    setTimeout(() => {
      linkRef.current.click();
    }, 1500);
  }, []); // eslint-disable-line

  return (
    <React.Fragment>
      <a href={addr} id="redirect" ref={linkRef} className="visually-hidden">
        Redirect to login
      </a>
      <div className="flex-column text-center">
        <h1>
          <FormattedMessage
            id="redirect.loggingouttext"
            defaultMessage="Logging you out"
            description="Opens editing something"
          />
        </h1>
        <LoadingSpinner />
      </div>
    </React.Fragment>
  );
}

export default connect()(RedirectToLogin);
